import { useMutation, useQuery } from "@tanstack/react-query";
import { SearchDto } from "../../../assets/utils/lib/searchDto";
import { IActionResponse, IActionResult, QuestionnaireClient } from "../../../services/proxies";
import { LookupQuestionTypeDto } from "../../../services/dto";

export namespace QuestionTypeService {
  const questionnaireClient = new QuestionnaireClient();

    export const save = () =>
        useMutation<IActionResult<LookupQuestionTypeDto>, Error, LookupQuestionTypeDto>({
      mutationFn: async (payload: LookupQuestionTypeDto) => {
        return await questionnaireClient.saveLookupQuestionTypeAsync(payload);
      },
    });

  export const getQuestionTypeQuery = (questionId: string | undefined) =>
    useQuery({
      queryKey: ["questiontypeQuery", questionId],
      queryFn: async () => await questionnaireClient.getLookupQuestionTypeAsync(questionId),
      enabled: Boolean(questionId),
    });

  export const gridQuery = (searchQuery: SearchDto) =>
    useQuery({
        queryKey: ["questiontypeGridQuery", searchQuery],
      queryFn: async () =>
        await questionnaireClient.searchLookupQuestionTypesAsync(searchQuery),
    });

  export const deActivateQuestiontype = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (questionId: string | undefined) => {
        return await questionnaireClient.deleteLookupQuestionTypeAsync(questionId);
      },
    });

  export const getQuestionTypesQuery = () =>
    useQuery({
      queryKey: ["QuestionTypesQuery"],
      queryFn: async () => await questionnaireClient.getLookupQuestionTypesAsync(),
    });
}
